import { Box, Typography } from '@mui/material'
import { AbsolutelyCentered } from 'elements/utils'

import { AnimatedLoader } from './animated-loader'

type Props = {
  centered?: boolean
  text?: string
  /** Size of a single dot in pixels. Default is 12px */
  size?: number
}

export const Loader = ({ centered, text, size = 12 }: Props) => {
  const content = (
    <Box display="flex" flexDirection="column" alignItems="center">
      <AnimatedLoader size={size} />
      {text && (
        <Typography variant="caption3" color="text.secondary" mt={1}>
          {text}
        </Typography>
      )}
    </Box>
  )

  if (centered) {
    return <AbsolutelyCentered>{content}</AbsolutelyCentered>
  }

  return content
}
